import { gql } from "@apollo/client";

export default gql`
  mutation PlatformCertificate($passphrase: String!, $file:Image) {
    PlatformCertificate( passphrase: $passphrase, file: $file) {
      message
      status
      id
    }
  }
`;
